import { useTranslation } from 'react-i18next';

import ConfirmDeletionModal from '../../../components/Modal/ConfirmDeletionModal';
import { useCancelRequestToJoin } from './requestsToJoin.mutations';
import { RequestToJoinBody } from '../../../api/generated/pap';
import { useProcessJoinRequests } from './useProcessJoinRequests';

interface Props {
  selectedRequests: RequestToJoinBody[];
  open: boolean;
  onClose: (shouldUpdate: boolean) => void;
}

function DeclineRequestModal({ selectedRequests, open, onClose }: Props) {
  const { t } = useTranslation('users');
  const { mutateAsync: deleteRequestToJoin } = useCancelRequestToJoin();
  const { headers, data, processRequests } = useProcessJoinRequests(
    selectedRequests,
    'declined',
    onClose
  );
  const count = selectedRequests.length;

  const handleDeclineRequest = () => processRequests((req) => deleteRequestToJoin(req.id));

  return (
    <ConfirmDeletionModal
      title={t('declineRequestConfirmation')}
      description={t('declineRequestModal.infoText', { count })}
      headers={headers}
      data={data}
      primaryButtonText={t('declineRequestModal.declineRequestButton', { count })}
      iconName="account_circle"
      iconColor="icon.muted"
      open={open}
      onSubmit={handleDeclineRequest}
      onClose={onClose}
    />
  );
}

export default DeclineRequestModal;
